import '@bryntum/calendar/locales/calendar.locale.En';
import '@bryntum/calendar/locales/calendar.locale.EnGb';
import '@bryntum/calendar/locales/calendar.locale.De';
import '@bryntum/calendar/locales/calendar.locale.FrFr';
import '@bryntum/calendar/locales/calendar.locale.It';
import '@bryntum/calendar/locales/calendar.locale.Es';
import '@bryntum/calendar/locales/calendar.locale.Ru';
import '@bryntum/calendar/locales/calendar.locale.No';
import '@bryntum/calendar/locales/calendar.locale.Pt';

export const mapLocaleToBryntumLocale = (locale: string) => {
  const bryntumLocaleMap: Record<string, string> = {
    // English
    en: 'EnGb',
    'en-us': 'En',
    // German
    de: 'De',
    'de-ch': 'De',
    // French
    fr: 'FrFr',
    // Italian
    it: 'It',
    // Spanish
    es: 'Es',
    // Russian
    ru: 'Ru',
    // Norwegian
    no: 'No',
    // Portuguese
    pt: 'Pt',
  };

  return bryntumLocaleMap[locale] || 'En';
};
